import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';

export default function AboutPage() {
  return (
    <>
      <ScrollToTop />
      <Navbar />

      <main className="pt-16">
        <Breadcrumb
          items={[
            { label: '首页', path: '/' },
            { label: '关于我们' },
          ]}
        />

        <section className="w-full px-4 md:px-6 py-10 md:py-16">
          <div className="max-w-5xl mx-auto">
            <div className="text-center mb-12">
              <h1 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 mb-4">
                关于<span className="text-primary-500">BB体育</span>
              </h1>
              <p className="text-foreground-500 text-base md:text-lg max-w-2xl mx-auto">
                专业体育赛事服务平台，致力于为全球体育爱好者提供极致的赛事体验
              </p>
            </div>

            <div className="aspect-[21/9] rounded-xl overflow-hidden mb-14">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20sports%20technology%20headquarters%20office%20with%20multiple%20screens%20displaying%20sports%20data%2C%20clean%20professional%20environment%2C%20warm%20ambient%20lighting%2C%20contemporary%20workspace%20design%2C%20no%20people%2C%20editorial%20style%2C%20sleek%20minimalist%20aesthetic&width=1600&height=600&seq=about-hero-bb&orientation=landscape"
                alt="BB体育"
                className="w-full h-full object-cover object-top"
              />
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-14">
              <div className="lg:col-span-2">
                <h2 className="font-heading text-2xl font-bold text-foreground-900 mb-5">品牌介绍</h2>
                <div className="space-y-4 text-foreground-700 leading-relaxed">
                  <p>
                    <strong className="text-foreground-900">BB体育</strong>成立于2020年，是一家专注于体育赛事服务的综合性平台。我们致力于为全球体育爱好者提供专业、全面、实时的体育赛事资讯和服务。
                  </p>
                  <p>
                    平台涵盖<strong className="text-foreground-900">足球、篮球、网球、电竞、F1赛车、高尔夫、拳击、综合格斗</strong>等多项热门体育项目，为用户提供赛事直播、实时比分、数据分析、深度解读等全方位服务。
                  </p>
                  <p>
                    BB体育拥有一支由资深体育媒体人、数据分析师和技术专家组成的专业团队，确保每一条资讯的准确性和时效性。我们的编辑团队遍布全球主要体育城市，第一时间为您带来最前沿的赛事报道。
                  </p>
                  <p>
                    我们相信，体育的魅力在于连接每一个人。无论您是资深体育迷还是刚刚开始关注体育赛事，BB体育都将为您提供最优质的体验和服务。
                  </p>
                </div>
              </div>

              <div className="bg-background-100 rounded-xl p-6">
                <h3 className="font-heading text-lg font-bold text-foreground-900 mb-4">核心数据</h3>
                <div className="space-y-4">
                  {[
                    { value: '200+', label: '覆盖赛事类型' },
                    { value: '50万+', label: '服务用户数' },
                    { value: '99.9%', label: '服务稳定性' },
                    { value: '24/7', label: '全天候更新' },
                    { value: '5大', label: '核心体育板块' },
                  ].map((item) => (
                    <div key={item.label} className="flex items-center justify-between py-2 border-b border-background-200/70 last:border-0">
                      <span className="text-foreground-500 text-sm">{item.label}</span>
                      <span className="font-heading text-lg font-bold text-primary-500">{item.value}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="mb-14">
              <h2 className="font-heading text-2xl font-bold text-foreground-900 mb-6">平台信誉</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                {[
                  {
                    icon: 'ri-shield-check-line',
                    title: '安全可靠',
                    desc: '采用先进的数据加密技术，全方位保障用户信息安全与隐私。',
                  },
                  {
                    icon: 'ri-customer-service-2-line',
                    title: '专业客服',
                    desc: '7×24小时在线客服团队，随时为您解答疑问，提供贴心服务。',
                  },
                  {
                    icon: 'ri-speed-line',
                    title: '实时更新',
                    desc: '赛事数据实时同步，比分更新毫秒级响应，不错过任何精彩瞬间。',
                  },
                  {
                    icon: 'ri-global-line',
                    title: '全球覆盖',
                    desc: '覆盖全球主要体育赛事，多语言支持，服务世界各地的体育爱好者。',
                  },
                ].map((item) => (
                  <div key={item.title} className="bg-background-50 border border-background-200/70 rounded-lg p-5">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-50 mb-3">
                      <i className={`${item.icon} text-lg text-primary-500`}></i>
                    </div>
                    <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">{item.title}</h3>
                    <p className="text-foreground-500 text-sm leading-relaxed">{item.desc}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-14">
              <div>
                <h2 className="font-heading text-2xl font-bold text-foreground-900 mb-5">联系我们</h2>
                <div className="space-y-4">
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-50 flex-shrink-0">
                      <i className="ri-mail-line text-lg text-primary-500"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-foreground-900 text-sm">电子邮箱</h4>
                      <p className="text-foreground-500 text-sm">service@bbtiyu.com</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-50 flex-shrink-0">
                      <i className="ri-customer-service-2-line text-lg text-primary-500"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-foreground-900 text-sm">在线客服</h4>
                      <p className="text-foreground-500 text-sm">7×24小时全天候在线服务</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-50 flex-shrink-0">
                      <i className="ri-map-pin-line text-lg text-primary-500"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-foreground-900 text-sm">服务范围</h4>
                      <p className="text-foreground-500 text-sm">服务覆盖全球多个国家和地区</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-50 flex-shrink-0">
                      <i className="ri-smartphone-line text-lg text-primary-500"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-foreground-900 text-sm">手机版</h4>
                      <p className="text-foreground-500 text-sm">支持iOS和Android移动设备访问</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-background-100 rounded-xl p-6">
                <h3 className="font-heading text-lg font-bold text-foreground-900 mb-4">常见问题</h3>
                <div className="space-y-4">
                  {[
                    {
                      q: 'BB体育平台如何注册？',
                      a: '访问BB体育官网，点击右上角"立即注册"按钮，按照指引填写基本信息即可完成注册，整个过程仅需1分钟。',
                    },
                    {
                      q: 'BB体育支持哪些体育项目？',
                      a: 'BB体育支持足球、篮球、网球、电竞、F1赛车、高尔夫、拳击、综合格斗等超过200种体育赛事类型。',
                    },
                    {
                      q: '如何获取最新赛事资讯？',
                      a: '您可以通过BB体育首页的最新资讯板块或分类页面获取实时更新的体育资讯，也可以关注我们的社交媒体账号获取推送通知。',
                    },
                    {
                      q: 'BB体育是否支持手机访问？',
                      a: '是的，BB体育完美支持手机浏览器访问，同时也提供移动端适配版本，让您随时随地获取体育资讯。',
                    },
                  ].map((faq, idx) => (
                    <details key={idx} className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden">
                      <summary className="flex items-center justify-between p-4 cursor-pointer font-medium text-foreground-900 text-sm list-none">
                        {faq.q}
                        <i className="ri-arrow-down-s-line group-open:rotate-180 transition-transform"></i>
                      </summary>
                      <div className="px-4 pb-4 text-foreground-600 text-sm leading-relaxed">
                        {faq.a}
                      </div>
                    </details>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于BB体育 - 专业体育赛事服务平台',
            description: 'BB体育成立于2020年，是一家专注于体育赛事服务的综合性平台，涵盖足球、篮球、网球、电竞等多项热门体育项目。',
            url: 'https://www.bbtiyu.com/about',
            isPartOf: {
              '@type': 'WebSite',
              name: 'BB体育',
              url: 'https://www.bbtiyu.com/',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: 'BB体育平台如何注册？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '访问BB体育官网，点击右上角"立即注册"按钮，按照指引填写基本信息即可完成注册，整个过程仅需1分钟。',
                },
              },
              {
                '@type': 'Question',
                name: 'BB体育支持哪些体育项目？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'BB体育支持足球、篮球、网球、电竞、F1赛车、高尔夫、拳击、综合格斗等超过200种体育赛事类型。',
                },
              },
              {
                '@type': 'Question',
                name: '如何获取最新赛事资讯？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '您可以通过BB体育首页的最新资讯板块或分类页面获取实时更新的体育资讯，也可以关注我们的社交媒体账号获取推送通知。',
                },
              },
              {
                '@type': 'Question',
                name: 'BB体育是否支持手机访问？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '是的，BB体育完美支持手机浏览器访问，同时也提供移动端适配版本，让您随时随地获取体育资讯。',
                },
              },
            ],
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: '首页',
                item: 'https://www.bbtiyu.com/',
              },
              {
                '@type': 'ListItem',
                position: 2,
                name: '关于我们',
              },
            ],
          }),
        }}
      />
    </>
  );
}